import React, { createContext, useContext, useEffect, useState } from 'react'
import { supabase, getConfiguracoes } from '../lib/supabase'

const TenantContext = createContext(null)

export function TenantProvider({ children }) {
  const [tenant, setTenant] = useState(null)
  const [carregandoTenant, setCarregandoTenant] = useState(true)
  const [erroTenant, setErroTenant] = useState(null)

  useEffect(() => {
    // Normaliza o hostname: remove o prefixo "www." para que
    // www.dominio.com e dominio.com resolvam o mesmo tenant na BD.
    const hostname = window.location.hostname.replace(/^www\./, '')
    const dominio = hostname === 'localhost'
      ? process.env.REACT_APP_TENANT_DEV_DOMINIO || 'mariana.agendaonline.pt'
      : hostname

    supabase
      .from('tenants')
      .select('id, slug, nome')
      .or(`dominio.eq.${dominio},dominio_dev.eq.${dominio}`)
      .eq('ativo', true)
      .single()
      .then(({ data, error }) => {
        if (error || !data) {
          setErroTenant('Espaço não encontrado.')
        } else {
          setTenant(data)
          // Título do separador = "Nome do negócio" das Configurações (nome_negocio),
          // com fallback para o nome do tenant.
          getConfiguracoes(data.id)
            .then(cfg => {
              const titulo = cfg?.nome_negocio || data.nome
              if (titulo) document.title = titulo
            })
            .catch(() => {
              if (data.nome) document.title = data.nome
            })
        }
      })
      .finally(() => setCarregandoTenant(false))
  }, [])

  return (
    <TenantContext.Provider value={{ tenant, carregandoTenant, erroTenant }}>
      {children}
    </TenantContext.Provider>
  )
}

export function useTenant() {
  const ctx = useContext(TenantContext)
  if (!ctx) throw new Error('useTenant deve ser usado dentro de TenantProvider')
  return ctx
}
